import { DISABLED_BUTTON } from '@etiquette-ui/colors';
import { P } from '@etiquette-ui/typography';
import styled from 'styled-components';

export const TextInactive = styled(P)`
    ${({ disabled }) => (disabled ? `color: ${DISABLED_BUTTON}; cursor: default;` : '')}
    user-select: none;
`;
